import React, { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

const STORAGE_KEY = 'ec-dark-mode';

function applyDark(on: boolean) {
  if (on) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

export default function DarkModeToggle() {
  const [dark, setDark] = useState<boolean>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) return stored === 'true';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    applyDark(dark);
    localStorage.setItem(STORAGE_KEY, String(dark));
  }, [dark]);

  return (
    <button
      type="button"
      className="dm-toggle"
      onClick={() => setDark(d => !d)}
      title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Sun always visible — active (lit) in light mode, muted in dark */}
      <span className="dm-sun">
        <Sun size={14} strokeWidth={2.5} />
      </span>
      {/* Moon always visible — muted in light mode, active (lit) in dark */}
      <span className="dm-moon">
        <Moon size={14} strokeWidth={2.5} />
      </span>
    </button>
  );
}
